import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: posts.Member.
export default class Member extends Fragment {
  declare [Type]: 'posts/member';

  @attr('string', { defaultValue: '' })
  declare personId: string;

  @attr('number', { defaultValue: 0 })
  declare status: number;
}
